export const CONSTS = {
  "API": {
    "URL": "https://api.snaily.io/api/v1/",
    "URL_AUTOMATION": "https://automation.snaily.io/v2/"
  },
  "APP_VERSION": "5.1.0.0",
  "TENOR_API_KEY": "AIzaSyAKGM0gVYDnyMz4vRg3JGtDImpvpV5Cl9I",
  "AVAILABLE_ACTIONS": {
    "Connect": {
      "MaxLength": 290,
      "Title": "Connect",
      "Type": "Connect",
      "Visible": true
    },
    "EndorseSkill": {
      "Title": "Endorse a skill",
      "Type": "EndorseSkill",
      "Visible": false
    },
    "Follow": {
      "Title": "Follow",
      "Type": "Follow",
      "Visible": true
    },
    "Message": {
      "MaxLength": 3000,
      "Title": "Message",
      "Type": "Message",
      "Visible": true
    },
    "ReactOnPost": {
      "Title": "Like a post",
      "Type": "ReactOnPost",
      "Visible": true
    },
    "ScrapeProfile": {
      "Title": "Scrape profile",
      "Type": "ScrapeProfile",
      "Visible": false
    },
    "VisitProfile": {
      "Title": "Visit Profile",
      "Type": "VisitProfile",
      "Visible": false
    }
  },
  "BETA_FEATURES": {
    "HUBSPOT_INTEGRATION_TEAMS": [
      "223bafffadb74a2ab4174f680eeefeea"
    ]
  },
  "CAMPAIGN_MAX_LENGTH": 50,
  "COLORS_CAMPAIGNS": {
    "cancelled": "#DEB4FF",
    "failed": "#ED0000",
    "ignored": "#EBD6FC",
    "inProgress": "var(--status-paused)",
    "inQueue": "#DCDCDC",
    "responded": "#04C300",
    "skipped": "#BC68FD"
  },
  "confirmationDialogs": {
    "1.1": {
      "content": "The system will stop all activities with this contact.",
      "title": "Cancel conversation?"
    },
    "1.10": {
      "content": "New campaign will be created.<br> It will contain the same steps.",
      "title": "Clone campaign?"
    },
    "1.11": {
      "content": "Subscription will be upgraded.<br> You might be prorated charge for a difference.",
      "title": "Upgrade subscription?"
    },
    "1.12": {
      "content": "Subscription will be downgraded.",
      "title": "Downgrade subscription?"
    },
    "1.13": {
      "content": "This message will be deleted for all participants in the conversation.",
      "title": "Delete message?"
    },
    "1.14": {
      "content": "This message will be deleted from scheduled queue.",
      "title": "Delete message?"
    },
    "1.2": {
      "content": "Stop all activities for this campaign.",
      "title": "Cancel campaign?"
    },
    "1.3": {
      "content": "Changes will not be saved.",
      "title": "Leave campaign master?"
    },
    "1.4": {
      "content": "This action and all next actions will be deleted.",
      "title": "Delete this action?"
    },
    "1.5": {
      "content": "Activities queue will be created for {contacts_count} contacts. <br>Edit of this campaign will be limited.",
      "title": "Launch now?"
    },
    "1.6": {
      "content": "Contacts will be excluded from this campaign.",
      "title": "Exclude contacts?"
    },
    "1.7": {
      "content": "It will be moved to the Archive.",
      "title": "Archive campaign?"
    },
    "1.8": {
      "content": "Contacts will be excluded from this campaign.",
      "title": "Exclude contacts?"
    },
    "1.9": {
      "content": "{contacts_count} contacts will be deleted from the system.",
      "title": "Delete contacts?"
    },
    "c1.13": {
      "content": "The invitation for {email} be deleted from the system.",
      "title": "Revoke invitation?"
    },
    "c1.14": {
      "content": "{nickname}({email}) will be removed.",
      "title": "Are you sure you want to remove this member?"
    },
    "c1.15": {
      "content": "This conversation will be deleted permanently.",
      "title": "Delete conversation from your inbox?"
    },
    "c1.16": {
      "content": "The system will resume chain of automatic actions.",
      "title": "Resume conversation?"
    }
  },
  "DAILY_LIMITS": {
    "FOLLOW": [
      {
        "label": "0",
        "value": "0"
      },
      {
        "label": "5",
        "value": "5"
      },
      {
        "label": "10",
        "value": "10"
      },
      {
        "label": "15",
        "value": "15"
      },
      {
        "label": "20",
        "value": "20"
      },
      {
        "label": "25",
        "value": "25"
      },
      {
        "label": "30",
        "value": "30"
      },
      {
        "label": "35",
        "value": "35"
      },
      {
        "label": "40",
        "value": "40"
      },
      {
        "label": "45",
        "value": "45"
      },
      {
        "label": "50",
        "value": "50"
      },
      {
        "label": "55",
        "value": "55"
      },
      {
        "label": "60",
        "value": "60"
      },
      {
        "label": "65",
        "value": "65"
      },
      {
        "label": "70",
        "value": "70"
      },
      {
        "label": "75",
        "value": "75"
      },
      {
        "label": "80",
        "value": "80"
      },
      {
        "label": "85",
        "value": "85"
      },
      {
        "label": "90",
        "value": "90"
      },
      {
        "label": "95",
        "value": "95"
      },
      {
        "label": "100",
        "value": "100"
      }
    ],
    "INVITATIONS": [
      {
        "label": "0",
        "value": "0"
      },
      {
        "label": "5",
        "value": "5"
      },
      {
        "label": "10",
        "value": "10"
      },
      {
        "label": "15",
        "value": "15"
      },
      {
        "label": "20",
        "value": "20"
      },
      {
        "label": "25",
        "value": "25"
      },
      {
        "label": "30",
        "value": "30"
      },
      {
        "label": "35",
        "value": "35"
      },
      {
        "label": "40",
        "value": "40"
      },
      {
        "label": "45",
        "value": "45"
      },
      {
        "label": "50",
        "value": "50"
      },
      {
        "label": "55",
        "value": "55"
      },
      {
        "label": "60",
        "value": "60"
      },
      {
        "label": "65",
        "value": "65"
      },
      {
        "label": "70",
        "value": "70"
      },
      {
        "label": "75",
        "value": "75"
      }
    ],
    "LIKES": [
      {
        "label": "0",
        "value": "0"
      },
      {
        "label": "5",
        "value": "5"
      },
      {
        "label": "10",
        "value": "10"
      },
      {
        "label": "15",
        "value": "15"
      },
      {
        "label": "20",
        "value": "20"
      },
      {
        "label": "25",
        "value": "25"
      },
      {
        "label": "30",
        "value": "30"
      },
      {
        "label": "35",
        "value": "35"
      },
      {
        "label": "40",
        "value": "40"
      },
      {
        "label": "45",
        "value": "45"
      },
      {
        "label": "50",
        "value": "50"
      },
      {
        "label": "55",
        "value": "55"
      },
      {
        "label": "60",
        "value": "60"
      },
      {
        "label": "65",
        "value": "65"
      },
      {
        "label": "70",
        "value": "70"
      },
      {
        "label": "75",
        "value": "75"
      },
      {
        "label": "80",
        "value": "80"
      },
      {
        "label": "85",
        "value": "85"
      },
      {
        "label": "90",
        "value": "90"
      },
      {
        "label": "95",
        "value": "95"
      },
      {
        "label": "100",
        "value": "100"
      }
    ],
    "MESSAGES": [
      {
        "label": "0",
        "value": "0"
      },
      {
        "label": "5",
        "value": "5"
      },
      {
        "label": "10",
        "value": "10"
      },
      {
        "label": "15",
        "value": "15"
      },
      {
        "label": "20",
        "value": "20"
      },
      {
        "label": "25",
        "value": "25"
      },
      {
        "label": "30",
        "value": "30"
      },
      {
        "label": "35",
        "value": "35"
      },
      {
        "label": "40",
        "value": "40"
      },
      {
        "label": "45",
        "value": "45"
      },
      {
        "label": "50",
        "value": "50"
      },
      {
        "label": "55",
        "value": "55"
      },
      {
        "label": "60",
        "value": "60"
      },
      {
        "label": "65",
        "value": "65"
      },
      {
        "label": "70",
        "value": "70"
      },
      {
        "label": "75",
        "value": "75"
      },
      {
        "label": "80",
        "value": "80"
      },
      {
        "label": "85",
        "value": "85"
      },
      {
        "label": "90",
        "value": "90"
      },
      {
        "label": "95",
        "value": "95"
      },
      {
        "label": "100",
        "value": "100"
      }
    ]
  },
  "DEFAULT_DATE_ACTIONS_VALUE": {
    "CONNECT": {
      "DELAY": {
        "DEFAULT": 30,
        "MIN_VALUE_MINUTES": 0
      },
      "WITHDRAW": {
        "DEFAULT": 10,
        "MIN_VALUE_DAYS": 7
      }
    },
    "MESSAGE_TIMEOUTS_DAYS": [
      3,
      7,
      14,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30,
      30
    ]
  },
  "DELAY_TIMEOUT": 1576800,
  "EMOTION": [
    "Like",
    "Celebrate",
    "Support",
    "Love",
    "Insightful",
    "Funny"
  ],
  "EXTENSION_ID": "febgaeoegckcdcdhammknmiobpjkpgbe",
  "BACKUP_EXTENSION_ID": "aimjcbfonanpejeiiehapkdjfnjmafck",
  "EXTENSION_INSTALL_URL": "https://chrome.google.com/webstore/detail/febgaeoegckcdcdhammknmiobpjkpgbe",
  "GOOGLE_TAG_MANAGER": {
    "ID": "GTM-KSFX6VJ"
  },
  "HELP_URL": "https://snaily.io/support/",
  "HJ_ID": 2778252,
  "HJ_SV": 6,
  "IMPORT_MAX_LENGTH": 50,
  "IS_RESIZABLE_TABLE": true,
  "LINKEDIN_URL": "https://www.linkedin.com/search/results/people",
  "LOGS_SETTINGS": {
    "didCatch": false,
    "rejection": false
  },
  "MAIN_CUSTOM_FIELDS": [
    "{first name}",
    "{last name}",
    "{company name}",
    "{position title}"
  ],
  "MESSAGING": {
    "AUTO_SYNC": true,
    "IGNORE_PERSONAS": [],
    "MAX_FILE_SIZE_MB": 20,
    "OFFLINE_INTERVAL_IN_MINUTES": 8,
    "REFRESH_INTERVAL_IN_SECONDS": 120
  },
  "EMOJI": {
    "DEFAULT_FREQUENTLY_USED_EMOJIS": [
      "👏",
      "👍",
      "😊"
    ],
    "FREQUENTLY_USED_VERSION": 1
  },
  "NICK_NAME_MAX_LENGTH": 50,
  "ON_BOARDING": {
    "INTRODUCTION_VIDEO": {
      "ENABLED": false,
      "URL": "https://www.youtube.com/embed/2pn8AYJVCCo"
    },
    "2.1": {
      "conditions": {
        "onBoarding": true,
        "runningActivitiesEnabled": false
      },
      "content": "Let’s make Snaily better together! Tell us more about your experience.",
      "isClosable": true,
      "title": "Leave us your feedback"
    },
    "2.2": {
      "conditions": {
        "onBoarding": true,
        "runningActivitiesEnabled": true
      },
      "content": "You can check scheduled actions in the activities queue.",
      "isClosable": true,
      "sideTitle": "2/2",
      "title": "Press to run activities on LinkedIn!"
    },
    "2.3": {
      "conditions": {
        "onBoarding": true,
        "runningActivitiesEnabled": false
      },
      "content": "Choose an action to set it up!",
      "isClosable": true,
      "title": "Step 1"
    },
    "2.4": {
      "conditions": {
        "onBoarding": true,
        "runningActivitiesEnabled": false
      },
      "content": "Create a sequence of follow-up messages!",
      "isClosable": true,
      "title": "Add next action"
    },
    "2.5": {
      "conditions": {
        "onBoarding": true,
        "runningActivitiesEnabled": false
      },
      "content": "Apply filters and add contacts to your campaign.",
      "isClosable": true,
      "title": "Available contacts"
    },
    "2.6": {
      "conditions": {
        "onBoarding": true,
        "runningActivitiesEnabled": false
      },
      "content": "All your active, paused and finished campaigns will be listed here.",
      "isClosable": true,
      "sideTitle": "1/2",
      "title": "Find your campaigns here!"
    },
    "2.7": {
      "conditions": {
        "onBoarding": true,
        "runningActivitiesEnabled": false
      },
      "content": "Press to rocket your campaign right now!",
      "isClosable": true,
      "title": "Launch your campaign!"
    }
  },
  "OVERFLOW_CUSTOM_FIELDS": [
    "{country}",
    "{custom field 1}",
    "{custom field 2}",
    "{custom field 3}"
  ],
  "PAGE_SIZE": 25,
  "PRIVACY_POLICY": "https://snaily.io/privacy-policy/",
  "PROJECT_NAME": "Snaily",
  "ROLES": {
    "Manager": "manager",
    "Owner": "owner",
    "User": "user"
  },
  "SALES_NAVIGATOR": "https://www.linkedin.com/sales/search/people",
  "SUBSCRIPTIONS": {
    "BASIC": {
      "ID": "basic",
      "NAME": "Basic",
      "PRICE": 38
    },
    "EXPERIMENTAL": {
      "ID": "early-birds",
      "NAME": "Early birds",
      "PRICE": 38
    },
    "PRO": {
      "ID": "pro",
      "NAME": "Pro ",
      "PRICE": 59
    },
    "STATE": {
      "ACTIVE": "active",
      "CANCELED": "canceled",
      "OVERDUE": "overdue"
    },
    "TEAM": {
      "ID": "team",
      "NAME": "Team",
      "PRICE": 75
    },
    "TRIAL": {
      "ID": "trial",
      "NAME": "Trial",
      "PRICE": 0
    }
  },
  "TERMS_AND_CONDITIONS_URL": "https://snaily.io/terms-and-conditions/",
  "TIME_ZONES": [
    {
      "label": "GMT-12:00",
      "value": "-720"
    },
    {
      "label": "GMT-11:00",
      "value": "-660"
    },
    {
      "label": "GMT-10:00",
      "value": "-600"
    },
    {
      "label": "GMT-09:30",
      "value": "-570"
    },
    {
      "label": "GMT-09:00",
      "value": "-540"
    },
    {
      "label": "GMT-08:00",
      "value": "-480"
    },
    {
      "label": "GMT-07:00",
      "value": "-420"
    },
    {
      "label": "GMT-06:00",
      "value": "-360"
    },
    {
      "label": "GMT-05:00",
      "value": "-300"
    },
    {
      "label": "GMT-04:00",
      "value": "-240"
    },
    {
      "label": "GMT-03:30",
      "value": "-210"
    },
    {
      "label": "GMT-03:00",
      "value": "-180"
    },
    {
      "label": "GMT-02:00",
      "value": "-120"
    },
    {
      "label": "GMT-01:00",
      "value": "-60"
    },
    {
      "label": "GMT-00:00",
      "value": "0"
    },
    {
      "label": "GMT+01:00",
      "value": "60"
    },
    {
      "label": "GMT+02:00",
      "value": "120"
    },
    {
      "label": "GMT+03:00",
      "value": "180"
    },
    {
      "label": "GMT+03:30",
      "value": "210"
    },
    {
      "label": "GMT+04:00",
      "value": "240"
    },
    {
      "label": "GMT+04:30",
      "value": "270"
    },
    {
      "label": "GMT+05:00",
      "value": "300"
    },
    {
      "label": "GMT+05:30",
      "value": "330"
    },
    {
      "label": "GMT+05:45",
      "value": "345"
    },
    {
      "label": "GMT+06:00",
      "value": "360"
    },
    {
      "label": "GMT+06:30",
      "value": "390"
    },
    {
      "label": "GMT+07:00",
      "value": "420"
    },
    {
      "label": "GMT+08:00",
      "value": "480"
    },
    {
      "label": "GMT+08:45",
      "value": "525"
    },
    {
      "label": "GMT+09:00",
      "value": "540"
    },
    {
      "label": "GMT+09:30",
      "value": "570"
    },
    {
      "label": "GMT+10:00",
      "value": "600"
    },
    {
      "label": "GMT+10:30",
      "value": "630"
    },
    {
      "label": "GMT+11:00",
      "value": "660"
    },
    {
      "label": "GMT+12:00",
      "value": "720"
    }
  ],
  "TIPS": {
    "n4.1": {
      "content": [
        "You used all monthly personalized invitations which LinkedIn gives for free every month and now your automation is stuck.",
        "Due to that we have paused this campaign.",
        "",
        "To resume this campaign you need to make an action first, we propose you to consider 2 options:",
        "- leave connection invitation message empty, LinkedIn allows to send message less invitations for free;",
        "- buy Premium LinkedIn or Sales Navigator, paid subscriptions don't have such limitations;",
        "",
        "Once you settle this you should just run this campaign once again."
      ],
      "more": "",
      "title": "Used free custom invitations"
    },
    "n4.2": {
      "content": [
        "Looks like you are using free LinkedIn which limits invitation messages up to 200 symbols.",
        "Your invitation message in this campaign is getting longer and we can't send it.",
        "Due to that we have paused this campaign.",
        "",
        "We would like to recommend you to consider next options to resume your campaign:",
        "- make the invitation message shorter, ideally it should be 190-195 symbols to let it be less than 200 symbols after personalization.",
        "Take into account that LinkedIn allows a limited number of personalized invitations for Free profiles, usually it is 5-10 invitations per month",
        "- buy one of the paid LinkedIn subscriptions like Premium or Sales Navigator.",
        "Such subscriptions allow you to send invitation messages up to 300 symbols without monthly limits.",
        "",
        "Once you settle this you should just run this campaign once again."
      ],
      "more": "",
      "title": "Too long invitation"
    },
    "n4.3": {
      "content": [
        "The weekly LinkedIn's  invitation limit has been reached.",
        "Snaily will resume sending invitations next week."
      ],
      "more": "",
      "title": "Out of invites"
    },
    "n4.4": {
      "content": [
        "Paste a text containing urls of LinkedIn profiles and Snaily will automatically recognize them. Once you export them you will get only profile URLs, contact details will be scraped during campaign execution."
      ],
      "more": "",
      "title": "Information"
    },
    "n4.5": {
      "content": [
        "This is advanced export that allows customizing LinkedIn profiles by changing profile information or adding custom fields. It is working only with a specific CSV file format. Please download the example to get familiar with it."
      ],
      "more": "",
      "title": "Information"
    }
  },
  "WORKING_HOURS": 10
}
